import { render, staticRenderFns } from "./study-compliance.vue?vue&type=template&id=4af57a98&scoped=true&"
import script from "./study-compliance.vue?vue&type=script&lang=js&"
export * from "./study-compliance.vue?vue&type=script&lang=js&"
import style0 from "./study-compliance.vue?vue&type=style&index=0&id=4af57a98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af57a98",
  null
  
)

component.options.__file = "study-compliance.vue"
export default component.exports